<template>
  <b-tag :type="difficultyColor" size="is-small" rounded>
    {{ difficultyIcon }} {{ difficulty }}
  </b-tag>
</template>

<script>
import { TopicDifficulty } from "vue-chess-shared";

export default {
  name: "DifficultyBadge",

  props: {
    difficulty: {
      type: String,
      required: true,
      validator: (value) => Object.values(TopicDifficulty).includes(value),
    },
  },

  computed: {
    difficultyColor() {
      const colors = {
        [TopicDifficulty.Beginner]: "is-danger is-light",
        [TopicDifficulty.Rookie]: "is-warning is-light",
        [TopicDifficulty.Intermediate]: "is-info is-light",
        [TopicDifficulty.Advanced]: "is-primary is-light",
      };
      return colors[this.difficulty] || "is-light";
    },

    difficultyIcon() {
      const icons = {
        [TopicDifficulty.Beginner]: "🐣",
        [TopicDifficulty.Rookie]: "🐤",
        [TopicDifficulty.Intermediate]: "🐥",
        [TopicDifficulty.Advanced]: "🦅",
      };
      return icons[this.difficulty] || "";
    },
  },
};
</script>
